import * as React from 'react';
import { IDistrictInfrastructureCell } from '../../../../../../types/newbuildingsCompare';
import * as styles from './styles.css';
import { Body1 } from '@cian/ui-kit';

export interface IDistrictInfrastructureCellProps {
  cell: IDistrictInfrastructureCell;
}

export const DistrictInfrastructureCell = ({ cell }: IDistrictInfrastructureCellProps): React.JSX.Element => {
  if (!cell.data?.items?.length) {
    return (
      <div className={styles['container']}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {cell.data.items.map((item, index) => (
        <Body1 key={index}>{item}</Body1>
      ))}
    </div>
  );
};
